(ns ui.wallet.register
  "UI register of the wallet slice: the /ui/subscription page and its
   rates, credit notes and customer conflict modals."
  (:require [ui.wallet.credit-notes :as credit-notes]
            [ui.wallet.customer-conflict :as customer-conflict]
            [ui.wallet.page :as page]
            [ui.wallet.rates :as rates]))

(def register
  [page/page
   rates/modal
   credit-notes/modal
   customer-conflict/modal])
